import { combineHash, combineUrl } from '@eureka/utils/url';

export function resolveEurekaLsLink(link: string) {
    if (link.startsWith('http://') || link.startsWith('https://')) return link;
    return combineHash(combineUrl(import.meta.env.VITE_EUREKA_URI, 'ls'), link);
}
